import type { FetchResult } from '@apollo/client';
import { createContext } from 'react';
import type { WorkflowDataType } from './workflowTypes';

export type WorkflowContextType = {
  workflowData: WorkflowDataType;
  setWorkflowData: (
    action:
      | WorkflowDataType
      | ((prevState: WorkflowDataType) => WorkflowDataType),
  ) => Promise<void> | void;
  updateWorkflowContext?: () => Promise<FetchResult<any>>;
  navigateToSegment?: (segment: string) => void;
  userId?: string;
};

export const WorkflowContext = createContext<WorkflowContextType>({
  workflowData: {},
  setWorkflowData: async () => {},
  updateWorkflowContext: async () => Promise.resolve({} as FetchResult<any>),
  navigateToSegment: () => {},
});
